// @flow

import { Map, fromJS } from 'immutable';

export const GET_VIDEO_DETAILS = 'App/Details/GET_VIDEO_DETAILS';
export const GET_VIDEO_DETAILS_SUCCESS = 'App/Details/GET_VIDEO_DETAILS_SUCCESS';
export const GET_VIDEO_DETAILS_FAIL = 'App/Details/GET_VIDEO_DETAILS_FAIL';

const initialState = Map({
  getVideoDetailsLoading: false,
  videoDetails: Map({}),
  getVideoDetailsFail: null,
});

export default (state : any = initialState, action : any = {}) => {
  switch (action.type) {
    case GET_VIDEO_DETAILS:
      return state.merge({
        getVideoDetailsLoading: true,
        getVideoDetailsFail: null,
      });
    case GET_VIDEO_DETAILS_SUCCESS:
      return state.merge({
        getVideoDetailsLoading: false,
        videoDetails: fromJS(action.data),
        getVideoDetailsFail: null,
      });
    case GET_VIDEO_DETAILS_FAIL:
      return state.merge({
        getVideoDetailsLoading: false,
        getVideoDetailsFail: fromJS(action.data),
      });
    default:
      return state;
  }
};

export const getVideoDetails = (data : string) => (dispatch : any) =>
  dispatch({ type: GET_VIDEO_DETAILS, data });
